// extracted by mini-css-extract-plugin
export default {"cls1":"FSIzKAUFTOBRijIZrBZo","cls2":"axC6KYxOyA8G0nUemvrm FSIzKAUFTOBRijIZrBZo","isPhone":"ZfM1gLXf_fSPCs4Mlloq"};